import { render } from "./WarningChip.vue?vue&type=template&id=1d78e552&scoped=true"
import script from "./WarningChip.vue?vue&type=script&lang=js"
export * from "./WarningChip.vue?vue&type=script&lang=js"

import "./WarningChip.vue?vue&type=style&index=0&id=1d78e552&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d78e552"

export default script